export default __webpack_public_path__ + "9661c59f86a11e7e9e26a4c7c3cd7085.png";